"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.970589,19.7775908 L10.3653616,20.970589 L4.41979548,12.970589 C4.18293196,12.6518796 4.1592456,12.2273571 4.34873642,11.887485 L4.41979548,11.7775908 L10.3653616,3.77759079 L11.970589,4.97058903 L6.46828301,12.3742444 L11.970589,19.7775908 Z M18.970589,19.7775908 L17.3653616,20.970589 L11.4197955,12.970589 C11.182932,12.6518796 11.1592456,12.2273571 11.3487364,11.887485 L11.4197955,11.7775908 L17.3653616,3.77759079 L18.970589,4.97058903 L13.468283,12.3742444 L18.970589,19.7775908 Z"
  });
}.bind(void 0));

exports.default = _default;